import { memo } from 'react';
import cn from 'classnames';
import { IconButton } from 'src/components/buttons';
import { RequireLoginButton } from '../RequireLoginButton';
import { useDispatch, useSelector } from 'react-redux';
import { isFollowSeclector } from 'src/selectors/user';
import * as UserAction from 'src/redux/actions/user';

interface IProps {
    className?: string;
    objectId: number;
    objectType: string;
    title?: string;
    icon?: string;
    iconFollow?: string;
    classIcon?: string;
    classIconFollow?: string;
}

const FollowButton = ({
    className,
    objectType,
    objectId,
    title = '',
    icon = 'star',
    iconFollow = 'star-bold',
    classIcon,
    classIconFollow,
}: IProps) => {
    const isFollow = useSelector(isFollowSeclector(objectType, objectId));
    const dispatch = useDispatch();

    const handleClick = () => {
        if (objectId) {
            dispatch(UserAction.follow(objectType, objectId));
        }
    };

    return (
        <RequireLoginButton onClickFn={handleClick}>
            <IconButton
                title={title}
                icon={isFollow ? iconFollow : icon}
                className={cn(
                    'follow-button flex items-center',
                    className,
                    isFollow ? classIconFollow : classIcon
                )}
                // classNameIcon={cn("text-[var(--primary)]")}
                text={title}
            />
        </RequireLoginButton>
    );
};

export default memo(FollowButton);
